module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-04.af53da90.png";